<template>
  <div>
    <v-toolbar color="indigo" dark>
      <v-toolbar-title v-if="!edit_mode">{{ article.title }}</v-toolbar-title>
      <v-toolbar-title v-else>
        <v-text-field
          v-model="article.title"
          label="Solo"
          solo
          hide-details
          single-line
          full-width
          dense
          append-icon="mdi-content-save"
          @click:append="update_article"
        ></v-text-field>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="edit_mode = !edit_mode">
        <v-icon>mdi-book-edit</v-icon>
      </v-btn>
      <v-btn icon>
        <v-icon>mdi-trash-can</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text>
      <ArticleEditor
        v-model="article.content"
        :instance_id="instance_id"
        :edit_mode="edit_mode"
      ></ArticleEditor>
    </v-card-text>
  </div>
</template>

<script>
import ArticleEditor from "./ArticleEditor.vue";

export default {
  name: "ArticleDisplay",
  components: {
    ArticleEditor,
  },
  props: ["article"],
  data() {
    return {
      edit_mode: false,
      instance_id: 1,
    };
  },
  methods: {
    update_article: function () {
      this.edit_mode = false;
    },
  },
};
</script>
